// extracted by css-extract-rspack-plugin
var _1 = "heading__obEsF";
var _2 = "heading__description__CLc8D";
export { _1 as "heading", _2 as "heading__description" }
export default { "heading": _1, "heading__description": _2 }
